export * from './src/promote-seo-v1-seo-pattern-seo-patterns.meta.js';
